/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import InlineNoteEditor from 'DesignSystem/InlineNoteEditor/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Edit/Note/Note",
  onChange
  
}) {
let editedNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'edited_note',
path: 'note',
})
let editedNoteNoteChangeData = fromData.useDataChange({ viewPath,
context: 'edited_note',
path: 'note',
})
let editedNoteIdValueData = fromData.useDataFormat({ viewPath,
context: 'edited_note',
path: 'id',
format: fromHelpers.getContainerId,
})
let appointmentNoteItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'appointment_note_item',
path: 'isLast',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onAutocompleteAction = fromHelpers.useOnAutocompleteAction({
  children,
  viewPath,
  onChange
  
})
let onAutocompleteFetch = fromHelpers.useOnAutocompleteFetch({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<InlineNoteEditor
  viewPath={`${viewPath}/InlineNoteEditor`}
 data="edited_note.note"
 value={editedNoteNoteValueData}
 onChange={editedNoteNoteChangeData}
 autocomplete={true}
 onAutocompleteAction={onAutocompleteAction}
 onAutocompleteFetch={onAutocompleteFetch}
 data="edited_note.id"
 format="helpers.js getContainerId"
 containerId={editedNoteIdValueData}
 marginBottom={appointmentNoteItemIsLastValueData ? "0px" : dtSpaceXs}
 data="appointment_note_item.isLast"
/>
{children}
</React.Fragment>)
}